import React from "react";
import styled from "styled-components";
import { colors } from "./colors";
import { Spinner } from "react-bootstrap";

const SwitchWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    width: 52px;
    height: 28px;
    background-color: ${(props) => (props.isActive ? colors[props.variant][900] : colors.neutral[200])};
    border-radius: 14px;
    padding: 2px;
    cursor: ${(props) => (props.loading ? "wait" : "pointer")};
    position: relative;
    transition: background-color 0.3s ease-in-out;
    opacity: ${(props) => (props.loading ? 0.7 : 1)};

    &::before {
        content: "";
        position: absolute;
        width: 1.37px;
        height: 10px;
        background-color: white;
        opacity: ${(props) => (props.isActive ? 1 : 0)};
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

        top: 50%;
        left: ${(props) => (props.isActive ? "32%" : "50%")};
        transform: translate(-50%, -50%);
    }

    /* Adding the text labels */
    &::after {
        content: "${(props) => !props.isActive && "O"}";
        position: absolute;
        top: 50%;
        ${(props) => (props.isActive ? "left: 10px;" : "right: 10px;")}
        transform: translateY(-50%);
        color: ${colors.neutral[500]};
        font-size: 13px;
    }
`;

const SwitchCircle = styled.div`
    width: 24px;
    height: 24px;
    background-color: ${colors.white};
    border-radius: 50%;
    transition: transform 0.3s ease-in-out;
    transform: ${(props) => (props.isActive ? "translateX(24px)" : "translateX(0)")};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledSpinner = styled(Spinner)`
    width: 16px;
    height: 16px;
`;

const Switch = ({ isActive, setIsActive, onClick, loading, variant = "primary" }) => {
    const toggleSwitch = () => {
        if (loading) return; // Prevent toggling while loading
        if (typeof setIsActive === "function") {
            setIsActive((prev) => !prev);
        }
    };

    return (
        <SwitchWrapper
            isActive={isActive}
            onClick={onClick ? (loading ? null : onClick) : toggleSwitch}
            role="button"
            aria-pressed={isActive}
            loading={loading}
            variant={variant}
        >
            <SwitchCircle isActive={isActive}>{loading && <StyledSpinner animation="border" size="sm" />}</SwitchCircle>
        </SwitchWrapper>
    );
};

export default Switch;
